import { useNavigate } from 'react-router-dom';

import { ActionFixedButtonStyled } from './styled';

import clsx from 'clsx';
import Button from 'src/components/Button';

interface ActionFixedButtonProps {
  className?: string;
}

const ActionFixedButton = ({ className }: ActionFixedButtonProps) => {
  const navigate = useNavigate();

  return (
    <ActionFixedButtonStyled className={clsx('ActionFixedButton', className)}>
      <Button
        radius
        className="pinNumberInput"
        color="#fff"
        textColor="#000"
        onClick={() => {
          localStorage.setItem('timer', `${new Date().getTime()}`);
          navigate('/motion');
        }}
      >
        Pin
      </Button>
    </ActionFixedButtonStyled>
  );
};

export default ActionFixedButton;
